export default "__VITE_ASSET__ca3eb486__"